const mContentEditorBlockInputAudio = {
  mContentEditorBlockInputAudio: {
    inputs: {
      audio: {
        placeholder: 'Pega aquí la url del audio.'
      }
    }
  }
}

export default mContentEditorBlockInputAudio
